/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';

import {Row, Col } from 'react-bootstrap';

import MicrositeSectionBasic from '../MicrositeSectionBasic/MicrositeSectionBasic';
import MicrositeSection from '../MicrositeSection';

import ContactCard from '../../../ContactCard/ContactCard';
import {Fade} from 'react-reveal';

class MicrositeSectionContacts extends MicrositeSectionBasic {
    constructor(props) {
        super(props);
    }

    render() {
        let content = [];
        if (this.props.contacts) {
            content.push(this.renderGrid("microsite-contacts-grid", this.props.maxItemsInRow, this.props.contacts));
        }

        return (this.props.contacts ? (
                <MicrositeSection
                    id={this.props.id}
                    name={this.props.name}
                    textCentered={this.props.textCentered}
                    colorTheme={this.props.colorTheme}
                    content={content}
                />
            ) : null
        );
    }

    renderItem(data){
        return (
            <Fade>
                <ContactCard
                    position={data.position}
                    name={data.name}
                    channels={data.channels}
                />
            </Fade>
        );
    }
}

MicrositeSectionContacts.propTypes = {
    maxItemsInRow: PropTypes.number,
    contacts: PropTypes.array
};

export default MicrositeSectionContacts;